export const PROJECT_STATUSES = {
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    PLANNED: 'planned',
};
export const PROJECT_STATUS_TITLES = {
    IN_PROGRESS: 'В процессе',
    COMPLETED: 'Завершен',
    PLANNED: 'Планируется',
};
